export default __webpack_public_path__ + "static/media/Neuvetica-Regular.ba484138.otf";